import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getContentPageBySlug } from '../../../services/contentPageService';
import Layout from '../../../components/public/common/Layout';
import ContentDetail from '../../../components/public/content/ContentDetail';
import LoadingSpinner from '../../../components/common/LoadingSpinner';

const ContentPage = ({ category }) => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        setError(null);
        
        if (!slug || !category) {
          throw new Error('Missing required parameters');
        }

        const data = await getContentPageBySlug(slug, category);
        
        if (!data) {
          throw new Error('Page not found');
        }

        setPage(data);
      } catch (err) {
        console.error('Error fetching page:', err);
        setError(err.message || 'Failed to fetch page');
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug, category]);

  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center items-center min-h-[60vh]">
          <LoadingSpinner size="lg" text="Loading page..." />
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="container mx-auto px-6 py-8">
          <div className="text-center text-red-600 dark:text-red-400">
            <h1 className="text-2xl font-bold mb-4">Error</h1>
            <p>{error}</p>
          </div>
        </div>
      </Layout>
    );
  }

  if (!page) {
    return (
      <Layout>
        <div className="container mx-auto px-6 py-8">
          <div className="text-center text-gray-600 dark:text-gray-400">
            <h1 className="text-2xl font-bold mb-4">Page Not Found</h1>
            <p>The requested page could not be found.</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <ContentDetail page={page} />
    </Layout>
  );
};

export default ContentPage; 